import React, { ReactChildren, ReactChild, useEffect, useContext } from 'react';
import { Box, Button, Card, Grid } from '@material-ui/core';
import cn from 'classnames';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import { makeStyles } from '@material-ui/core/styles';
import { APISideBarNavigation, AskPermission, SideBarNavigation, TopBarNavigation } from '../';
import usePermission from '../../lib/hooks/usePermission';
import { ThemeContext } from '../../lib/contexts';

export interface Props {
  title?: string;
  permission?: string;
  showHeader?: boolean;
  showFooter?: boolean;
  showSidebarNav?: boolean;
  showBreadcrumbs?: any; //[{name: string, path: string}];
  showTopNav?: boolean;
  showAPISidebarNav?: boolean;
  elevated?: boolean;
  showPaddingTop?: boolean;
  noBackground?: boolean;
  className?: string;
  children?: ReactChild | ReactChildren;
}

const useStyles = makeStyles(theme => ({
  root: {
    '& a': {
      color: 'inherit',
    },
    '& a:visited': {
      color: 'inherit',
    },
    '& a:hover': {
      color: 'inherit',
      textDecoration: 'underline',
    },
  },
  crumbs: {
    marginTop: -50,
  },
  screenPaddingOn: {
    padding: 16,
    '@media print': {
      padding: 0,
    },
  },
  screenPaddingOff: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  elevatedBox: {
    // backgroundColor: '#ff0044',
    paddingTop: theme.spacing(5),
  },
  childrenBox: {
    minHeight: '100vh', // @ts-ignore
    //    backgroundImage: `linear-gradient(167deg, ${theme.palette.backgrounds.background} 0%, ${theme.palette.backgrounds.login} 100%)`
    // backgroundImage: `linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)`
    // background: `linear-gradient(-180deg, #BCC5CE 0%, #929EAD 98%), radial-gradient(at top left, rgba(255,255,255,0.30) 0%, rgba(0,0,0,0.30) 100%); background-blend-mode: screen`
    backgroundColor: theme.palette.backgrounds.background,
  },
  childrenBoxDark: {
    minHeight: '100vh', // @ts-ignore
    backgroundColor: theme.palette.backgrounds.background,
    // backgroundImage: `linear-gradient(60deg, #29323c 0%, #485563 100%)`
    //background: `linear-gradient(190deg, #323232 0%, #3F3F3F 40%, #1C1C1C 150%), linear-gradient(to top, rgba(255,255,255,0.40) 0%, rgba(0,0,0,0.25) 200%); background-blend-mode: multiply`,
    // backgroundImage: `linear-gradient(60deg, #29323c 0%, #485563 100%)`,
  },
  childrenBoxNoBackground: {
    marginLeft: '0vh',
    minHeight: '100vh', // @ts-ignore
    minWidth: '-webkit-fill-available', // @ts-ignore
    background: 'transparent',
  },
  screenWithSidebar: {
    height: '100vh',
    marginLeft: 230,
    '@media print': {
      marginLeft: 0,
    },
  },
  screenWithAPISidebar: {
    height: '100vh',
    marginLeft: 250,
    '@media print': {
      marginLeft: 0,
    },
  },
  no_permission: {
    padding: 100,
    margin: 'auto',
    marginTop: 200,
    textAlign: 'center',
  },
}));

const Screen = ({
  title,
  permission = undefined,
  showHeader,
  showFooter,
  showSidebarNav,
  showBreadcrumbs,
  showAPISidebarNav,
  showTopNav,
  children,
  className,
  elevated = true,
  showPaddingTop = true,
  noBackground,
}: Props) => {
  const classes = useStyles();
  const hasPermission = usePermission(permission);
  const { darkMode } = useContext(ThemeContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box className={showSidebarNav ? classes.screenWithSidebar : showAPISidebarNav ? classes.screenWithAPISidebar : ''}>
      {showHeader && <Header title={title + ' | SendBoth'} />}
      {showSidebarNav && <SideBarNavigation />}
      {showAPISidebarNav && <APISideBarNavigation />}
      {showTopNav && <TopBarNavigation />}
      <Box
        className={cn(
          classes.root,
          elevated ? classes.screenPaddingOn : classes.screenPaddingOff,
          showPaddingTop && classes.elevatedBox,
          noBackground ? classes.childrenBoxNoBackground : darkMode ? classes.childrenBoxDark : classes.childrenBox,
          className,
        )}
        style={{ paddingBottom: 150 }}
      >
        <div className={classes.crumbs}>{showBreadcrumbs && <Breadcrumbs crumbs={showBreadcrumbs} />}</div>
        {permission ? hasPermission ? children : <AskPermission title={title} /> : children}
      </Box>
      {/*{showFooter && <Footer />}*/}
    </Box>
  );
};

export default Screen;
